// General
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// Redux Form
import { Field, reduxForm, formValueSelector } from 'redux-form';
// Redux
import { connect } from 'react-redux';
// Translation
import { injectIntl, FormattedMessage } from 'react-intl';
// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import {
  Button,
  FormGroup,
} from 'react-bootstrap';

// Internal Component
// OLD CODE - Map-based implementation (commented out for cost reduction)
// import PlaceMap from '../PlaceMap';

// NEW CODE - Coordinates input implementation
import CoordinatesInput from '../CoordinatesInput';

import FooterButton from './FooterButton';
import SidePanel from './SidePanel';
import Loader from '../Loader';

import s from './ListPlaceStep1.css';
import bt from '../../components/commonStyle.css';

// Locale
import messages from '../../locale/messages';
// Helpers
import validate from './validate';
import update from './update';

class Page6 extends Component {

  static propTypes = {
    initialValues: PropTypes.object,
    previousPage: PropTypes.any,
    nextPage: PropTypes.any,
    locationMap: PropTypes.object,
    isMapTouched: PropTypes.bool,
    lat: PropTypes.number,
    lng: PropTypes.number,
  };

  // ===== OLD CODE - Map-based implementation (commented out) =====
  // renderPlaceMap = ({ input, label, meta: { touched, error }, lat, lng, isMapTouched, mapWarning, mapSuccess }) => {
  //   const { formatMessage } = this.props.intl;
  //   return (
  //     <div className={'stpeOneMap'}>
  //       {touched && error && <span>{formatMessage(error)}</span>}
  //       <PlaceMap
  //         {...input}
  //         lat={lat}
  //         lng={lng}
  //         isMapTouched={isMapTouched}
  //         mapWarning={mapWarning}
  //         mapSuccess={mapSuccess}
  //       />
  //     </div>
  //   )
  // }

  // ===== NEW CODE - Coordinates input implementation =====
  renderCoordinatesInput = ({ input, label, meta: { touched, error } }) => {
    const { formatMessage } = this.props.intl;
    const { lat, lng } = this.props;
    return (
      <div>
        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
        <CoordinatesInput {...input} lat={lat} lng={lng} />

        {/* Help section with instructional media */}
        <div className={cx(s.helpSection, 'coordinatesHelpSection')}>
          <h4 className={s.helpTitle}>
            <FormattedMessage {...messages.coordinatesHelpTitle} />
          </h4>
          <p className={s.helpText}>
            1. <FormattedMessage {...messages.coordinatesHelpStep1} /><br/>
            2. <FormattedMessage {...messages.coordinatesHelpStep2} /><br/>
            3. <FormattedMessage {...messages.coordinatesHelpStep3} /><br/>
            4. <FormattedMessage {...messages.coordinatesHelpStep4} />
          </p>

          {/* Tutorial videos/GIFs section */}
          <div className={cx(s.tutorialsContainer, 'coordinatesTutorials')}>
            {/* Desktop tutorial */}
            <div className={cx(s.tutorialItem, 'tutorialDesktop')}>
              <h5 className={s.tutorialSubtitle}>
                <FormattedMessage {...messages.coordinatesTutorialDesktop} />
              </h5>
              <div className={s.tutorialMediaContainer}>
                {/* Option 1: GIF */}
                {/* <img
                  src="/public/SiteIcons/coordinates-desktop-tutorial.gif"
                  alt="Copy coordinates on desktop"
                  className={s.tutorialGif}
                /> */}
                {/* Option 2: Video (uncomment to use video instead of GIF) */}
                <video
                  className={s.tutorialVideo}
                  controls
                  loop
                  muted
                  playsInline
                >
                  <source src="/demo-videos/maps-desktop.webm" type="video/webm" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>

            {/* Mobile/App tutorial */}
            <div className={cx(s.tutorialItem, 'tutorialMobile')}>
              <h5 className={s.tutorialSubtitle}>
                <FormattedMessage {...messages.coordinatesTutorialMobile} />
              </h5>
              <div className={s.tutorialMediaContainer}>
                {/* Option 1: GIF */}
                {/* <img
                  src="/public/demo-videos/coordinates-mobile-tutorial.gif"
                  alt="Copy coordinates on mobile"
                  className={s.tutorialGif}
                /> */}
                {/* Option 2: Video (uncomment to use video instead of GIF) */}
                 <video
                  className={s.tutorialVideo}
                  controls
                  loop
                  muted
                  playsInline
                >
                  <source src="/demo-videos/maps-mobile.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video> 
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {

    const { error, handleSubmit, submitting, pristine, previousPage, nextPage } = this.props;
    const { locationMap, isMapTouched, lat, lng, formPage, step } = this.props;
    const { formatMessage } = this.props.intl;

    // ===== OLD CODE - Map validation (commented out) =====
    // let isDisabled = true;
    // if (isMapTouched === true || locationMap != undefined) {
    //   isDisabled = false;
    // }

    return (
      <div className={s.grid}>
        <SidePanel
          title={formatMessage(messages.stepOneCommonHeading)}
          landingContent={formatMessage(messages.whereLocated)}
        />
        <form onSubmit={handleSubmit}>
          {error && <strong>{formatMessage(error)}</strong>}
          <div className={s.landingMainContent}>
            <FormGroup className={s.formGroup}>

              {/* ===== OLD CODE - Map component (commented out) ===== */}
              {/* {
                !lat && !lng && <Loader type={"text"} />
              }
              {
                lat && lng &&
                <Field
                  name="locationMap"
                  component={this.renderPlaceMap}
                  lat={lat}
                  lng={lng}
                  isMapTouched={isMapTouched}
                  mapWarning={formatMessage(messages.mapWarning)}
                  mapSuccess={formatMessage(messages.mapSuccess)}
                />
              } */}

              {/* ===== NEW CODE - Coordinates input ===== */}
              <Field
                name="coordinatesInput"
                component={this.renderCoordinatesInput}
              />

            </FormGroup>
          </div>
          <FooterButton
            nextPage={nextPage}
            previousPage={previousPage}
            nextPagePath={"amenities"}
            previousPagePath={"location"}
            formPage={formPage}
            step={step}
          />
        </form>
      </div>
    )
  }
}

Page6 = reduxForm({
  form: 'ListPlaceStep1', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
  onSubmit: update
})(Page6);


// Decorate with connect to read form values
const selector = formValueSelector('ListPlaceStep1'); // <-- same as form name
Page6 = connect(
  state => {
    // can select values individually
    const locationMap = selector(state, 'locationMap');
    const isMapTouched = selector(state, 'isMapTouched');
    const lat = selector(state, 'lat');
    const lng = selector(state, 'lng');
    return {
      locationMap,
      isMapTouched,
      lat,
      lng,
    }
  }
)(Page6);

export default injectIntl(withStyles(s, bt)(Page6));